"use client";

import { useEffect, useState } from "react";
declare const wvcClient: any;
const getWvcClient = () => typeof wvcClient !== "undefined" ? wvcClient : typeof window !== "undefined" ? (window as any).wvcClient : undefined;
export default function Organization() {
  const [logoUrl, setLogoUrl] = useState<string | null>(null);
  useEffect(() => {
    let isMounted = true;
    const client = getWvcClient();
    if (client && typeof client.getLogo === "function") {
      try {
        Promise.resolve(client.getLogo()).then((res: any) => {
          if (isMounted && res?.url) {
            setLogoUrl(res.url);
          }
        }).catch(() => {
          // Ignore error, logo field is optional
        });
      } catch {
        // Ignore runtime retrieval failure
      }
    }
    return () => {
      isMounted = false;
    };
  }, []);
  const schemaData: Record<string, string> = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "Fridge Fleet LLC",
    url: "https://fridgefleet.com/",
    telephone: "+1-213-521-8821",
    email: "Info@Fridgefleet.com",
    foundingDate: "2026",
    areaServed: "Southern California and the Las Vegas area"
  };
  if (logoUrl) {
    schemaData.logo = logoUrl;
  }
  return <section id="organizationschema" data-nav="light" className="hidden" aria-hidden="true">
      <script type="application/ld+json" dangerouslySetInnerHTML={{
      __html: JSON.stringify(schemaData)
    }} />
    </section>;
}